import React from 'react'
import './ShipmentTrackingMethod.css'

const ShipmentMethod = ({ methodDetails }) => {
    const methods = methodDetails?.shipment_tracking_method ?? []

    return (
        <div>
            <h3 className="data_header">Shipment and Tracking Methods</h3>
            <table id="methods">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Methods used</th>
                        <th>Details of methods used</th>
                        <th>GPS Service Provider(s) used to track shipment/trucks</th>
                    </tr>
                </thead>
                {methods.length === 0 ? (
                    <tbody>
                        <tr>
                            <td colSpan="4">Details not available</td>
                        </tr>
                    </tbody>
                ) : (
                    <tbody>
                        {methods.map((method, index) => (
                            <tr key={index}>
                                <td className="shipment_td">{index + 1}</td>
                                <td className="shipment_td">{method.methods_used}</td>
                                <td className="shipment_td">{method.details_of_method}</td>
                                <td className="shipment_td">{method.service_provider}</td>
                            </tr>
                        ))}
                    </tbody>
                )}
            </table>
        </div>
    )
}

export default ShipmentMethod
